<template>
  <a
    class="btn btn-amber"
    target="_blank"
    rel="nofollow noopener"
    data-track-auto="off"
    :href="link"
    @click="trackClickout"
  >
    <span :class="{ 'hidden lg:inline': responsive }">
      {{ $t('go_to', { provider: provider.displayName })
      }}<span class="whitespace-nowrap"
        >&nbsp;<svg role="presentation" focusable="false" tabindex="-1" class="icon icon-xs align-baseline -rotate-90"
           
          alt=""
          svg-inline
       xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 19">
  <path fill="currentColor" fill-rule="evenodd"
    d="M.8 1.18a2.26 2.26 0 0 1 3.2 0L16 13.2 28.03 1.18a2.26 2.26 0 0 1 3.2 3.2L17.6 17.97c-.88.9-2.31.9-3.2 0L.8 4.39a2.26 2.26 0 0 1 0-3.2Z"
    clip-rule="evenodd" />
</svg></span>
    </span>
    <span v-if="responsive" class="lg:hidden">{{ $t('go') }}</span>
  </a>
</template>

<script lang="ts" setup>
import type { PaymentType, Corridor } from '@core/types/imt'
import { comparisonResultClickout } from './analytics/actions'
import type { Provider } from './types'
import { Comparison } from './analytics/objects/Comparison'
import { ComparisonSection } from './analytics/objects/ComparisonSection'
import { ComparisonResult } from './analytics/objects/ComparisonResult'

const props = defineProps<{
  provider: Provider
  location: string
  responsive?: boolean
  promotion?: { coupon: string | null } | null
}>()

const { $track } = useNuxtApp()

const corridor = inject('corridor') as Corridor
const activeTabType = inject<Ref<PaymentType>>('activeTabType')
const {
  public: { redirectUrl },
} = useRuntimeConfig()

const link = computed(() => {
  const coupon = props.promotion?.coupon ? `&cpn=${props.promotion.coupon}` : ''
  return addAffiliateMobileAppParams(
    `${redirectUrl}/${props.provider.slug}?src=results` +
      `&cta=${props.location}` +
      `&cof=${corridor.countryFrom.iso.toLowerCase()}&cot=${corridor.countryTo.iso.toLowerCase()}` +
      `&cuf=${corridor.currencyFrom.iso.toLowerCase()}&cut=${corridor.currencyTo.iso.toLowerCase()}` +
      `&amt=${corridor.amount || corridor.defaultAmount}` +
      `&po=${activeTabType?.value}` +
      coupon,
  )
})

const comparisonAnalyticsObj = inject<Ref<Comparison>>('comparisonAnalyticsObj')
const sectionAnalyticsObj = inject<Ref<ComparisonSection>>('sectionAnalyticsObj')
const getResultAnalyticsObj = inject('getResultAnalyticsObj') as (
  slug: string,
  location: string,
) => ComparisonResult | undefined
async function trackClickout() {
  return comparisonResultClickout(
    $track,
    comparisonAnalyticsObj?.value,
    sectionAnalyticsObj?.value,
    getResultAnalyticsObj(props.provider.slug, props.location),
  )
}
</script>
